(function ($) {
  function norm(s) {
    return (s || '').toString().toLowerCase().trim();
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function getYearValueFromFilterItem(el) {
    var $label = $(el).find('.custom-control-label').first().clone();
    $label.find('.count_value').remove();

    var labelText = norm($label.text());
    var match = labelText.match(/\b(19|20)\d{2}\b/);

    return match ? parseInt(match[0], 10) : null;
  }

  function sortYearFilters(scope) {
    var $scope = scope ? $(scope) : $(document);

    $scope.find('.sidebar-widget ul.checkbox-container').each(function () {
      var $list = $(this);

      if ($list.hasClass('sidebar-price-filter')) return;

      var items = $list.children('li').get();
      if (items.length < 2) return;

      var parsedYears = items.map(getYearValueFromFilterItem);
      var isYearOnlyFilter = parsedYears.every(function (year) {
        return year !== null;
      });

      if (!isYearOnlyFilter) return;

      items.sort(function (a, b) {
        return getYearValueFromFilterItem(b) - getYearValueFromFilterItem(a);
      });

      $list.append(items);
    });
  }

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 991px)').matches;
  }

  function beforeFilterNav() {
    try {
      sessionStorage.setItem('bookly_reopen_filters', '1');
      var drawer = document.getElementById('booklyFilterDrawer');
      if (drawer) sessionStorage.setItem('bookly_filter_scroll', String(drawer.scrollTop || 0));
    } catch (e) {}
  }

  $(function () {
    window.Bookly = window.Bookly || {};
    window.Bookly.beforeFilterNav = beforeFilterNav;

    // Quick search: filtrer synlige produkter på siden
    var $q = $('#booklyCollectionQuickSearch');
    if ($q.length) {
      var run = debounce(function () {
        var needle = norm($q.val());
        var $cards = $('.theme-products .product-wrapper-class');

        if (!$cards.length) return;

        if (!needle) {
          $cards.each(function () {
            $(this).closest('[class*="col-"]').show();
          });
          return;
        }

        $cards.each(function () {
          var $card = $(this);
          var text =
            norm($card.find('.theme-product-title').text()) + ' ' +
            norm($card.find('.theme-product-vendor').text());

          var show = text.indexOf(needle) !== -1;
          $card.closest('[class*="col-"]')[show ? 'show' : 'hide']();
        });
      }, 80);

      $q.on('input', run);

      $q.on('keydown', function (e) {
        if (e.key === 'Escape') {
          $q.val('');
          $q.trigger('input');
          $q.blur();
        }
      });
    }

    // Mobil: filter drawer open/close
    var $filterToggle = $('.bookly-mobile-filter-toggle');

    function openFilters() {
      document.documentElement.classList.add('bookly-filters-open');
      $filterToggle.attr('aria-expanded', 'true');
    }

    function closeFilters() {
      document.documentElement.classList.remove('bookly-filters-open');
      $filterToggle.attr('aria-expanded', 'false');
      try {
        sessionStorage.removeItem('bookly_reopen_filters');
        sessionStorage.removeItem('bookly_filter_scroll');
      } catch (e) {}
    }

    function toggleFilters(e) {
      if (e) { e.preventDefault(); e.stopPropagation(); }
      if (document.documentElement.classList.contains('bookly-filters-open')) {
        closeFilters();
      } else {
        openFilters();
      }
    }

    // Kun click (ikke touchend). Dette gjør den stabil på iPhone.
    $(document).on('click', '.bookly-mobile-filter-toggle', toggleFilters);

    $(document).on('click', '.bookly-filter-drawer-close', function (e) {
      e.preventDefault();
      closeFilters();
    });

    $(document).on('click', '[data-bookly-filter-overlay]', function () {
      closeFilters();
    });

    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') closeFilters();
    });

    // Når filter-formen submitter (checkbox eller pris), husk at drawer skal åpnes igjen etter reload
    $(document).on('submit', '#myform', function () {
      if (isMobile()) beforeFilterNav();
    });

    // Når du klikker "fjern" eller "fjern alle" inne i filterpanelet
    $(document).on('click', '.active-filter-data-remove, .active-filters-clear, .filter-reset-selected-value', function () {
      if (isMobile()) beforeFilterNav();
    });

    // Reopen drawer etter at siden har reloadet pga filtervalg
    try {
      if (isMobile() && sessionStorage.getItem('bookly_reopen_filters') === '1') {
        openFilters();
        var st = parseInt(sessionStorage.getItem('bookly_filter_scroll') || '0', 10) || 0;
        setTimeout(function () {
          var drawer = document.getElementById('booklyFilterDrawer');
          if (drawer) drawer.scrollTop = st;
        }, 50);

        sessionStorage.removeItem('bookly_reopen_filters');
        sessionStorage.removeItem('bookly_filter_scroll');
      }
    } catch (e) {}

    // Sørg for at årstall-filter alltid vises numerisk, nyeste øverst
    sortYearFilters();

    // Søk i filterverdier (innenfor samme filter-boks)
    $(document).on('input', '.bookly-filter-values-search-input', debounce(function () {
      var needle = norm($(this).val());
      var $widget = $(this).closest('.sidebar-widget');
      var $items = $widget.find('ul.checkbox-container li');

      if (!needle) {
        $items.show();
        return;
      }

      $items.each(function () {
        var t = norm($(this).text());
        $(this)[t.indexOf(needle) !== -1 ? 'show' : 'hide']();
      });
    }, 80));

          // iOS: sørg for at søkefeltet alltid får fokus på første trykk
    function booklyFocusQuickSearch() {
      var el = document.getElementById('booklyCollectionQuickSearch');
      if (!el) return;

      // FastClick: native click/focus
      el.classList.add('needsclick');

      try {
        el.focus({ preventScroll: true });
      } catch (err) {
        el.focus();
      }
    }

    // Trykk hvor som helst på søkeboksen (wrapper) => fokus i input
    $(document).on('click', '.bookly-collection-quicksearch', function () {
      booklyFocusQuickSearch();
    });

    $(document).on('touchend', '.bookly-collection-quicksearch', function () {
      booklyFocusQuickSearch();
    });



  });
})(jQuery);
